// extracted by mini-css-extract-plugin
module.exports = {"contactdiv":"styles_contactdiv__1UJaR","logo":"styles_logo__1cW7g","contactinfodiv":"styles_contactinfodiv__2ngEh"};